import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface EMSReponse {
    type: 'ems';
    emsId: string;
    vin: string;
    location: string;
    customer: string;
    roNumber: string;
    vehicle: string;
    insurance: string | null;
    claimNumber: string | null;
}

export interface OrderReponse {
    type: 'order';
    orderId: string;
    vin: string;
    location: string;
    customer: string;
    roNumber: string;
    vehicle: string;
    archived: boolean;
    insurance: string | null;
    claimNumber: string | null;
}

interface SearchResponse {
    results: Array<EMSReponse | OrderReponse>;
}

const search = async (sessionId: string, searchString: string): Promise<SearchResponse> => {
    const { data } = await axios.post(`${API_URL}/search`,
        { searchString },
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
    return data;
};

export const useSearch = (searchString: string, enabled: boolean = false) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        // Session, not just the query: employees switch orgs by switching sessions.
        queryKey: ['/search', sessionContext?.sessionId, searchString],
        queryFn: () => search(sessionContext?.sessionId ?? '', searchString),
        enabled: !!sessionContext?.sessionId && enabled && searchString.length > 0,
        staleTime: 10 * 1000,
        gcTime: 10 * 1000,
    });
};
